// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__N3lqJ","pulse":"styles_pulse__9dcnv","jump":"styles_jump__dDCwz","wiggle":"styles_wiggle__yLVSy"};